<template lang="pug">
    div
        timeline-theme-item.dragItem(
                v-if="video.id == 'intro' || video.id == 'outro'"
                :video="video",
                 :class="{active: isActive }",

              )
        timeline-clip-item.dragItem.draggable(
                v-else-if="video.element === VideoElement.CLIP"
                :video="video",
                :class="{active: isActive }",
                :itemsCount="itemsCount"
              )
        find-video-dialog(v-if="video.id == '_add'")
      
</template>
<script>
import urlFormat from "@/utils/urlFormat";

import TimelineClipItem from "@/components/create/timelineItems/TimelineClipItem";
import TimelineThemeItem from "@/components/create/timelineItems/TimelineThemeItem";
import FindVideoDialog from "@/components/search/FindVideoDialog";
import {  VideoElement } from "@/models";

export default {
  name: "TimelineItem",
  props: ["video", "itemsCount", "isActive"],
  data() {
    return {VideoElement};
  },
  components: {
    TimelineClipItem,
    TimelineThemeItem,
    FindVideoDialog
  },
  computed: {},
  methods: {
    ...urlFormat,
    async chooseAsActive() {
      this.$emit("clicked", this.video);
    },
  },
};
</script>
<style lang="sass" scoped>
.active
  transition: all 0.4s ease
  transform: scale(1.05)
<style>